import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Switch from "react-switch";
import { WorkflowModel } from "app/models";
import styles from "./styles.module.scss";

interface IProps {
  workflow: WorkflowModel;
  onSave: (_params: Partial<WorkflowModel>) => void;
  onDelete: () => void;
}

const WorkflowSettingsPanel = ({ workflow, onSave, onDelete }: IProps) => {
  const { t } = useTranslation();
  const [name, setName] = useState(workflow.name || "");
  const [enabled, setEnabled] = useState(workflow.enabled || false);

  useEffect(() => {
    setName(workflow.name || "");
    setEnabled(workflow.enabled || false);
  }, [workflow.name, workflow.enabled]);

  const handleSave = () => {
    const trimmed = name.trim();
    if (!trimmed) {
      return;
    }
    onSave({ name: trimmed, enabled });
  };

  const handleDelete = () => {
    if (window.confirm(t("Are you sure you want to delete this workflow?"))) {
      onDelete();
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.field}>
        <label className={styles.label}>{t("Workflow Name")}</label>
        <input
          type="text"
          className={styles.input}
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>

      <div className={styles.field}>
        <label className={styles.label}>{t("Status")}</label>
        <div className={styles.toggle_row}>
          <span className={styles.toggle_label}>
            {enabled ? t("Active") : t("Inactive")}
          </span>
          <Switch
            checked={enabled}
            onChange={setEnabled}
            offColor="#CECECE"
            onColor="#27A4FF"
            onHandleColor="#FFFFFF"
            handleDiameter={20}
            uncheckedIcon={false}
            checkedIcon={false}
            height={24}
            width={40}
          />
        </div>
      </div>

      <button
        type="button"
        className={styles.save_btn}
        onClick={handleSave}
        disabled={!name.trim()}
      >
        {t("Save")}
      </button>

      <div className={styles.danger_zone}>
        <button
          type="button"
          className={styles.delete_btn}
          onClick={handleDelete}
        >
          {t("Delete Workflow")}
        </button>
      </div>
    </div>
  );
};

export default WorkflowSettingsPanel;
